// Stockage du token et signalement des sessions invalides.
//
// Ce module existe pour casser un cycle d'imports : client.ts a besoin de lire le token,
// et AuthContext a besoin d'être averti d'un 401. Les deux dépendent donc d'ici, et non
// l'un de l'autre.

const STORAGE_KEY = "wsdadmin.jwt";

export function getStoredToken(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function storeToken(token: string | null) {
  if (token) localStorage.setItem(STORAGE_KEY, token);
  else localStorage.removeItem(STORAGE_KEY);
}

let unauthorizedHandler: (() => void) | null = null;

/**
 * Enregistre le traitement d'une session invalide. AuthProvider y branche sa purge de
 * token : le garde de route renvoie alors sur la page de connexion de lui-même, au lieu
 * de laisser l'utilisateur devant un message lui demandant de se déconnecter à la main.
 */
export function setUnauthorizedHandler(handler: (() => void) | null) {
  unauthorizedHandler = handler;
}

export function notifyUnauthorized() {
  unauthorizedHandler?.();
}
